import React from "react";
import { motion } from "framer-motion";
// Import partner logos
import cape from "../assets/partners/cape.png";
import ho from "../assets/partners/Ho.png";
import kath from "../assets/partners/kath.png";
import kbth from "../assets/partners/kbth.png";
import tamale from "../assets/partners/tamale.png";
import ugmc from "../assets/partners/ugmc.png";
import vra from "../assets/partners/vra.png";

const partners = [
  { name: "Cape Coast Teaching Hospital", logo: cape },
  { name: "Ho Teaching Hospital", logo: ho },
  { name: "Komfo Anokye Teaching Hospital", logo: kath },
  { name: "Korle Bu Teaching Hospital", logo: kbth },
  { name: "Tamale Teaching Hospital", logo: tamale },
  { name: "University of Ghana Medical Centre", logo: ugmc },
  { name: "Volta Regional Hospital", logo: vra },
];

export default function Partners() {
  return (
    <section className="py-16 bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Trusted Partners
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Proudly serving leading healthcare facilities across Ghana
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-medical-blue-600 to-medical-teal-600 mx-auto mt-6 rounded-full"></div>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-6 md:gap-8 items-center">
          {partners.map((partner, index) => (
            <motion.div
              key={partner.name}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
              className="flex items-center justify-center p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-all duration-300 border border-gray-200 hover:border-medical-blue-300 hover:shadow-md"
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="max-w-full max-h-16 object-contain transition-all duration-300"
                title={partner.name}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
